function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import styled from "styled-components";
import { P, FlexRow, Icon } from "../../";
export const FormMessage = ({
  content = "",
  type = "error",
  active = true,
  InternalField = ErrorMessageContainer,
  ...props
}) => {
  let color = type === "error" ? "red" : type === "info" ? "blue" : "green";
  return active && /*#__PURE__*/React.createElement(InternalField, _extends({
    yStart: true,
    color: color
  }, props), type === "error" && /*#__PURE__*/React.createElement(ErrorIcon, {
    form: true,
    name: "Error"
  }), type === "success" && /*#__PURE__*/React.createElement(SuccessIcon, {
    badge: true,
    name: "FacebookVerified"
  }), type === "info" && /*#__PURE__*/React.createElement(InfoIcon, {
    indicator: true,
    name: "Information"
  }), /*#__PURE__*/React.createElement(Message, {
    color: color
  }, content));
};
const ErrorMessageContainer = styled(FlexRow)`
  background-color: ${props => props.theme.palette[props.color].lightest};
  border: 1px solid ${props => props.theme.palette[props.color].lighter};
  min-height: 54px;
  padding: 16px 24px;
  width: 100%;
  @media only screen and ${props => props.theme.media.small} {
    padding: 12px;
  }
`;
const Message = styled(P).attrs({
  as: "div"
})`
  color: ${props => props.color !== "info" ? props.theme.palette[props.color].primary : props.theme.palette.black};
`;
const ErrorIcon = styled(Icon)`
  display: inline-flex;
  flex-shrink: 0;
  margin-top: 3px;
  margin-right: 16px;
  position: relative;
  width: 16px;
  @media only screen and ${props => props.theme.media.small} {
    display: none;
  }
`;
const SuccessIcon = styled(ErrorIcon)`
  path {
    fill: ${props => props.theme.palette.green.primary};
  }
`;
const InfoIcon = styled(ErrorIcon)`
  path {
    fill: ${props => props.theme.palette.black};
  }
`;